<!-- @format -->

<a class="sis-external-link" [href]="href" target="_blank" rel="noopener noreferrer">
  <span class="sis-external-link__icon-wrapper">
    <ng-content></ng-content>
    <sis-icon icon="new-tab" color="primary-dark"></sis-icon>
  </span>
  <span class="visually-hidden" translate>ARIA_LABEL.OPENS_TO_A_NEW_TAB</span>
</a>
